import { Box } from "@mui/material";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { getToken } from "./api/token";
import Index from "./components";
import Sidebar from "./components/sidebar/sidebar";
import Login from "./pages/login";
import Signin from "./pages/signin";
import SigninGruop from "./pages/signinGruop";
import SigninMujahid from "./pages/signinMujahid";
import Axios from "axios";
import ForgetPassword from "./pages/forgetPassword";
// import './index.css';
import "./styles/global.css";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect, useState } from "react";
import { getDigest } from "./api/user";
import SidebarGroup from "./components/sidebar/sidebarGroup";
import DashboardGroup from "./components/dashboardGroup";
import { getAllRegions } from "./api/area";
import Insurer from "./components/areaManager/sidebarArea/insurer/insurer";
import Parvandeh from "./parvandeh";
import { myCartableAreas } from "./api/jahadgar";

export const BaseUrl = "http://37.152.177.240:8080";
// export const BaseUrl = "http://192.168.219.29:8081";
// export const BaseUrl = "http://192.168.43.204:8081";
export const apiAgent = Axios.create({ baseURL: BaseUrl });
export const apiAgentWithToken = Axios.create({ baseURL: BaseUrl });

apiAgent.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiAgentWithToken.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (!config.headers.Authorization && token) {
      config.headers.Authorization = `Bearer ${token}`;
      // config.headers.Authorization = `Bearer ${"eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJrb29jaGl0YSIsImF1dGgiOnsiYXV0aG9yaXR5IjoiUk9MRV9BRE1JTiJ9LCJpYXQiOjE2ODk0MjcyMDksImV4cCI6MTY5MDAzMjAwOX0.u0xP9RexMHiI7eClKs5IJe_Y1_YHzP2lNDvOP5ozgTU"}`;
    }
    // setToken(
    //   "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJtbWRIIiwiYXV0aCI6eyJhdXRob3JpdHkiOiJST0xFX0NMSUVOVCJ9LCJpYXQiOjE2OTA4MDE0NzgsImV4cCI6MTY5MTQwNjI3OH0.RUFd8ctKnOGu8DIekMofAipvZNLRyeYypXAV7dev7XE"
    // );
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// var role;
function App() {
  const [digest, setDigest] = useState();
  const [data, setData] = useState();
  const [sidebarAreaData, setSidebarAreaData] = useState();
  const navigate = useNavigate();

  console.log(digest);

  useEffect(() => {
    if (!getToken()) {
      navigate("/login");
    } else {
      getDigest()
        .then((x) => setDigest(x))
        .catch(() => {});
    }
  }, [getToken()]);
  useEffect(() => {
    if (getToken()) {
      if (digest) {
        if (digest.hasActiveRegion) {
          getAllRegions()
            .then((x) => setData(x))
            .catch(() => {});
        } else {
          myCartableAreas()
            .then((x) => setData(x))
            .catch(() => {});
        }
      }
    }
  }, [getToken(), digest]);
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Box display="flex" sx={{ height: "100vh", overflow: "hidden" }}>
        {window.location.pathname !== "/login" &&
          window.location.pathname !== "/signin" &&
          window.location.pathname !== "/signin/group" &&
          window.location.pathname !== "/signin/mujahid" &&
          window.location.pathname !== "/forgetPassword" &&
          window.location.pathname !== "/parvandeh" &&
          data && (
            <>
              <Sidebar data={data} sidebarAreaData={sidebarAreaData} setData={setData} Role={digest} />
              <Index data={data} setSidebarAreaData={setSidebarAreaData} setData={setData} digest={digest} />
            </>
          )}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/signin/mujahid" element={<SigninMujahid />} />
          <Route path="/signin/group" element={<SigninGruop />} />
          <Route path="/parvandeh" element={<Parvandeh dataArea={data} />} />
        </Routes>
      </Box>
    </>
  );
}

export default App;
